var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyAction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.146 20.501a.49.49 0 01-.428-.51.478.478 0 01.015-.131l.942-7.349c0 .009-.049-.015-.146-.015H4.674a.84.84 0 01-.8-.441.828.828 0 01.153-.891L12.173.694a.49.49 0 01.688-.085.488.488 0 01.19.4.5.5 0 01-.008.11L11.65 8.38a.1.1 0 00.022.08.081.081 0 00.067.029h3.588a.842.842 0 01.822.385.746.746 0 01-.114.809l-7.362 10.5a.49.49 0 01-.461.325.442.442 0 01-.066-.007zm-3.151-8.988H8.53a1.166 1.166 0 01.873.349.978.978 0 01.25.75l-.7 5.452 6.028-8.594h-3.245a1.069 1.069 0 01-.817-.377 1.1 1.1 0 01-.239-.89l1.019-5.3z",
    stroke: "transparent",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .5h20v20H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyAction);
export default __webpack_public_path__ + "static/media/KeyAction.d4cd72d55c5cedd115476694ef42e9f4.svg";
export { ForwardRef as ReactComponent };